'use client';

import { FC } from 'react';
import { TrustBar } from '@/views/products/components';
import { ProductFAQ, ProductCTAFooter } from '@/views/products/components';
import {
  CompareHero,
  FeatureTable,
  WhySwitching,
  WhatWeDoBetter,
  ChooseSection,
  AwardsBadges,
} from './components';
import { ComparisonData } from './types';

interface ComparePageProps {
  data: ComparisonData;
}

const ComparePage: FC<ComparePageProps> = ({ data }) => {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <CompareHero data={data} />

      {/* Trust Bar - Company Logos */}
      <TrustBar />

      {/* Feature Comparison Table */}
      <FeatureTable data={data} />

      {/* Testimonial Section */}
      <WhySwitching data={data} />

      {/* Benefits Section */}
      <WhatWeDoBetter data={data} />

      {/* Side-by-side Comparison */}
      <ChooseSection data={data} />

      {/* Awards & Badges */}
      <AwardsBadges />

      {/* FAQ Section */}
      <ProductFAQ faqs={data.faqs} />

      {/* CTA Footer */}
      <ProductCTAFooter
        title="Smarter sales. Faster results."
        subtitle="Powered by marketbetter"
      />
    </div>
  );
};

export default ComparePage;
